import { useTranslation } from '$shared/utils';
import { useMemo } from 'react';
import { StockStatus } from '../stock-status';

export function useStockMessage(stockStatus: StockStatus) {
    const { translate } = useTranslation();
    return useMemo(() => translate(`stock.stock-message-${stockStatus}`), [stockStatus]);
}
